import { AmountLeftHint } from '@shared/constants/utils';

// Shane-specific AB test response
export interface ShaneAbTestData {
  amount_left_hint: AmountLeftHint;
}

// Generic AB test response
export type GenericAbTestData = Record<string, string>;

// Union type for all possible AB test responses
export type AbTestData = ShaneAbTestData | GenericAbTestData;

/** AB test key gating the first-visit onboarding overlay (EAI-1807). */
export const ONBOARDING_AB_TEST_KEY = 'onboarding';

/** Variants of the onboarding AB test. */
export enum OnboardingAbTestVariant {
  SWIPE = 'swipe',
}
